export default __webpack_public_path__ + "static/media/devonta-video.771e1288.mp4";